import SignUpForm from 'features/auth/components/organisms/SignUpForm/SignUpForm';

export default SignUpForm;
